import rules from './rules'
import {
  fetchOrderListInvoice,
  fetchInvoiceList,
  fetchInvoiceMoney,
  fetchorderListInfo,
  fetchInvoiceInfo,
  fetchInvoiceHistory,
  fetchInvoiceApply,
  fetchProviceCityDatas
} from '@/services/account'
export default {
  namespaced: true,
  state: {
    loadingDetails: false,
    decorators: {
      contenttype: rules.contenttype,
      title: rules.title,
      identifynumber: rules.identifynumber,
      regaddress: rules.regaddress,
      regtel: rules.regtel,
      bankdeposit: rules.bankdeposit,
      bankaccount: rules.bankaccount,
      consignee: rules.consignee,
      contact: rules.contact,
      address: rules.address,
      email: rules.email
    },
    datasReady: false,
    historyDataReady: false,
    current: '1',
    invoiceMoney: 0,
    invoiceDatas: [],
    invoiceHistoryDatas: [],
    datas: [],
    provinceCityDatas: []
  },
  mutations: {
    setLoadingDetails (state, type) {
      state.loadingDetails = type
    },
    setHistoryDataReady (state, type) {
      state.historyDataReady = type
    },
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setCurrentIndex (state, id) {
      state.current = id
    },
    setInvoiceMoney (state, number) {
      state.invoiceMoney = number
    },
    setInvoiceDatas (state, datas) {
      state.invoiceDatas = datas
      state.datasReady = true
    },
    setInvoiceHistoryDatas (state, datas) {
      state.invoiceHistoryDatas = datas
    },
    setProvinceCityDatas (state, datas) {
      state.provinceCityDatas = datas
    }
  },
  getters: {
    orderListData (state) {
      const { datas } = state
      datas.forEach(item => {
        item['key'] = item.id
      })
      return datas
    },
    invoiceListData (state) {
      const { invoiceDatas } = state
      invoiceDatas.forEach(item => {
        item['key'] = item.id
      })
      return invoiceDatas
    },
    invoiceHistoryListData (state) {
      const { invoiceHistoryDatas } = state
      invoiceHistoryDatas.forEach(item => {
        item['key'] = item.id
        item['invoicetitle'] = item.title
      })
      return invoiceHistoryDatas
    }
  },
  actions: {
    // 获取未开发票列表
    async fetchOrderListDatas ({ commit }) {
      commit('datasReady', false)
      const chain = await fetchOrderListInvoice()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    // 获取已开发票列表
    async fetchInvoiceListDatas ({ commit, dispatch }) {
      commit('setLoadingDetails', true)
      const chain = await fetchInvoiceList()
        .onSuccess(async (raw) => {
          commit('setInvoiceDatas', raw.list)
        })
        .onNetComplete(() => {
          commit('setLoadingDetails', false)
        })
        .config({ tip: false })
      return chain
    },
    // 获取可开发票金额
    async fetchInvoiceMoneyDatas ({ commit, dispatch }) {
      const chain = await fetchInvoiceMoney()
        .onSuccess(async (raw) => {
          commit('setInvoiceMoney', raw.invoicemoney)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    // 获取未开发票详情
    async fetchOrderInfo ({ commit, dispatch }) {
      const chain = await fetchorderListInfo()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    // 获取已开发票详情
    async fetchInvoiceDetailDatas ({ commit, dispatch }) {
      const chain = await fetchInvoiceInfo()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    // 获取发票历史列表
    async fetchInvoiceHistoryDatas ({ commit, dispatch }) {
      commit('setHistoryDataReady', false)
      const chain = await fetchInvoiceHistory()
        .onSuccess(async (raw) => {
          commit('setInvoiceHistoryDatas', raw.list)
        })
        .onNetComplete(() => {
          commit('setHistoryDataReady', true)
        })
        .config({ tip: false })
      return chain
    },
    // 获取省市区
    async fetchProviceCityDatas ({ commit, dispatch }) {
      commit('setHistoryDataReady', false)
      const chain = await fetchProviceCityDatas()
        .onSuccess(async (raw) => {
          // commit('setProvinceCityDatas', raw)
        })
        .onNetComplete(() => {
          commit('setHistoryDataReady', true)
        })
        .config({ tip: false })
      return chain
    },
    // 申请发票
    async ajaxApplyInvoice ({ commit, dispatch }) {
      commit('setHistoryDataReady', false)
      const chain = await fetchInvoiceApply()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
          commit('setHistoryDataReady', true)
        })
        .config({ tip: false })
      return chain
    }
  }
}
